import { render } from "./VisualizacionCAPComponent.vue?vue&type=template&id=2127b718&scoped=true"
import script from "./VisualizacionCAPComponent.vue?vue&type=script&lang=js"
export * from "./VisualizacionCAPComponent.vue?vue&type=script&lang=js"

import "./VisualizacionCAPComponent.vue?vue&type=style&index=0&id=2127b718&scoped=true&lang=css"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2127b718"]])

export default __exports__